export default __webpack_public_path__ + "static/media/audience-comparison.png";